import React from "react";
import { Spin } from "antd";

export const Loading = ({ contentPreloader }) => {
  return contentPreloader ? <Spin className="content-preloader" /> : <Spin />;
};
